// Remembers the HLB team board view when a link leaves it, so profile and
// edit pages can offer the way back.
export const TEAM_BACK_KEY = 'hlb.teamBackTo';
// A trip from the board to a profile and its edit page; older than this, the
// button is no longer offered.
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

/** Router state for a link leaving the board (no side effect; safe in render). */
export const teamBoardState = () => ({ backTo: `${window.location.pathname}${window.location.search}` });

/**
 * Called on click of every link that leaves the HLB team board: remembers the board
 * view (person, filters…) so profile and edit pages can offer the way back.
 * Returns the router state to put on the link.
 */
export const rememberTeamBoard = () => {
  const url = `${window.location.pathname}${window.location.search}`;
  try {
    sessionStorage.setItem(TEAM_BACK_KEY, JSON.stringify({ url, at: Date.now() }));
  } catch {
    // storage unavailable: the router state below still covers the first page
  }
  return { backTo: url };
};

export const storedBoard = () => {
  try {
    const v = JSON.parse(sessionStorage.getItem(TEAM_BACK_KEY) || 'null');
    return v && Date.now() - v.at < MAX_AGE_MS ? v.url : null;
  } catch {
    return null;
  }
};

